import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewChildren,
  QueryList
} from '@angular/core';
import { Answer } from '../../../../../models/suitability/answer';
import { Question } from '../../../../../models/suitability/question';
import { TextAnswerComponent } from './text-answer/text-answer.component';

@Component({
  selector: 'app-multi-text-question',
  templateUrl: './multi-text-question.component.html',
  styleUrls: ['./multi-text-question.component.scss']
})
export class MultiTextQuestionComponent implements OnInit {
  @ViewChildren(TextAnswerComponent)
  suitabilityQuestionsControls: QueryList<TextAnswerComponent>;

  @Input() id: string;
  @Input() title: string;
  @Input() answerses: Answer[];
  @Input() value?: Question;
  @Input() disabled = false;
  @Input() showUserAnswer: boolean;

  @Output() onAnswerValueChange = new EventEmitter<Question>();

  answerModel: Question;

  ngOnInit() {
    this.answerModel = { id: this.id, answerses: [], answerChosen: null };
  }

  isValidControl(): boolean {
    return !this.suitabilityQuestionsControls
      .map((instance) => instance.isValidControl())
      .includes(false);
  }

  markControlAsTouched() {
    this.suitabilityQuestionsControls.map((instance) =>
      instance.markControlAsTouched()
    );
  }

  getQuestionID(): string {
    return this.id;
  }

  getValueText(answers: Answer) {
    if (this.value) {
      return this.value.answerses.find((args) => args.id === answers.id);
    }
    return null;
  }


  onAnswerTextChange(answer: Answer) {
    const answerses = this.answerModel.answerses;
    if (answerses.findIndex((args) => args.id === answer.id) > -1) {
      this.answerModel.answerses.splice(answerses.findIndex((args) => args.id === answer.id), 1);
    }
    this.answerModel.answerChosen = answer;
    this.answerModel.answerses.push({ ...answer });
    this.onAnswerValueChange.emit(this.answerModel);
  }
}
